import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // Scroll to the end (right side) of the container
    this.element.scrollLeft = this.element.scrollWidth
  }
}
